import React, { useState } from "react";

const Header = ({ headers, onSorting }) => {
    const [sortingField, setSortingField] = useState("");
    const [sortingOrder, setSortingOrder] = useState("asc");

    const onSortingChange = (field, type) => { 
        const order =
            field === sortingField && sortingOrder === "asc" ? "desc" : "asc";

        setSortingField(field);
        setSortingOrder(order);
        onSorting(field, order, type);
    };

    return (
        <thead>
            <tr>
                {headers.map(({ name, field, sortable, className, type }) => (
                    <th
                        className={className}
                        key={name}
                        onClick={() =>
                            sortable ? onSortingChange(field, type) : null
                        }
                    >
                        {name}

                        {sortingField && sortingField === field && (
                            sortingOrder === "asc"
                                ? <span className="srt"><i className="fas fa-sort-up active" aria-hidden="true"></i><i className="fas fa-sort-down" aria-hidden="true"></i></span>
                                : <span className="srt"><i className="fas fa-sort-up" aria-hidden="true"></i><i className="fas fa-sort-down active" aria-hidden="true"></i></span>
                        )}
                        {sortable && sortingField !== field && <i className="fas fa-sort" aria-hidden="true"></i>}
                    </th>
                ))}
            </tr>
        </thead>
    );
};

export default Header;
